import { API_CONFIG, STORAGE_KEYS, API_ENDPOINTS } from "../constants/api";

// Create a fetch wrapper with default configuration
export const apiRequest = async (endpoint, options = {}) => {
  const url = `${API_CONFIG.BASE_URL}${endpoint}`;

  const defaultOptions = {
    headers: {
      ...API_CONFIG.HEADERS,
      ...options.headers,
    },
    timeout: API_CONFIG.TIMEOUT,
  };

  // Add authorization header if token exists
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
  if (token) {
    defaultOptions.headers.Authorization = `Bearer ${token}`;
  }

  const publicAuthEndpoints = [
    API_ENDPOINTS.AUTH.LOGIN,
    API_ENDPOINTS.AUTH.REGISTER,
    API_ENDPOINTS.AUTH.FORGOT_PASSWORD,
  ];
  const isPublicAuthEndpoint =
    publicAuthEndpoints.includes(endpoint) ||
    endpoint.startsWith(`${API_ENDPOINTS.AUTH.RESET_PASSWORD}/`);

  // For protected routes, require a token.
  if (!token && !isPublicAuthEndpoint) {
    throw new Error("No authentication token found. Please log in.");
  }

  const config = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);
    const data = await response.json();

    return {
      ok: response.ok,
      status: response.status,
      data,
    };
  } catch (error) {
    throw new Error(`Network error: ${error.message}`);
  }
};

// HTTP method helpers
export const api = {
  get: (endpoint, options = {}) =>
    apiRequest(endpoint, { ...options, method: "GET" }),

  post: (endpoint, body, options = {}) =>
    apiRequest(endpoint, {
      ...options,
      method: "POST",
      body: JSON.stringify(body),
    }),

  put: (endpoint, body, options = {}) =>
    apiRequest(endpoint, {
      ...options,
      method: "PUT",
      body: JSON.stringify(body),
    }),

  delete: (endpoint, options = {}) =>
    apiRequest(endpoint, { ...options, method: "DELETE" }),
};
